export const WEBHOOK_FIELDS = {
    WEBHOOKS: {
        ID: 'webhooks',
        NAME: 'Webhooks'
    }
};

export const TIER_FIELDS = {
    TIER: {
        ID: 'tier',
        NAME: 'Tier'
    },
    DCS_SERVICES: {
        ID: 'dcsServices',
        NAME: 'DCS Services'
    }
};

export const ASSETS_FIELDS = {
    TIERS: {
        ID: 'tiers',
        NAME: 'Tiers'
    }
};

export const SYSLOG_FIELDS_V2 = {
    SYSLOG_SERVERS: {
        ID: 'syslogServers',
        NAME: 'Syslog Servers'
    }
};
export const NHI_FIELDS = {
    ON_PREM: {
        ID: 'nhi_on_prem',
        NAME: 'nhi on prem'
    },
    EXCLUDE_NAMING_CONVENTIONS: {
        ID: 'excludedConditions',
        NAME: 'excluded naming conventions'
    },
    INCLUDE_NAMING_CONVENTIONS: {
        ID: 'conditions',
        NAME: 'conditions'
    },
    EXCLUDE_USER_AND_GROUP: {
        ID: 'excludedUsersAndGroups',
        NAME: 'excluded users and groups'
    },
    INCLUDE_USER_AND_GROUP: {
        ID: 'usersAndGroups',
        NAME: 'users and groups'
    }
};

export const EMAIL_FIELDS = {
    EMAILS: {
        ID: 'emails',
        NAME: 'Emails'
    }
};

export const COMPANY_INFO_FIELDS = {
    COMPANY_NAME: {
        ID: 'companyName',
        NAME: 'Company Name'
    },
    COMPANY_LOGO: {
        ID: 'companyLogo',
        NAME: 'Company Logo',
        DESC: 'This logo is displayed in the Silverfort Mobile App. '
    },
    COMPANY_SUPPORT_EMAIL: {
        ID: 'companySupportEmail',
        NAME: 'Organization Support Email',
        DESC: 'All support requests from the mobile app are sent to this address.'
    },
    SNMP_ACCOUNT: {
        ID: 'snmpAccount',
        NAME: 'SNMP Account',
        DESC: 'To monitor Silverfort using SNMP, create and configure the SNMP account.'
    },
    WINDOWS_LOGON_TOKEN: {
        ID: 'windowsLogonToken',
        NAME: 'Silverfort for Windows Logon Token',
        DESC: 'Token for Silverfort for Windows Logon'
    },
    CLEAN_AUTH_LOGS: {
        ID: 'cleanAuthLogs',
        NAME: 'Authentication Logs Cleanup (Weeks)',
        DESC: 'Length of time authentication logs are kept before they are deleted'
    },
    MAX_AUTH_AGG_THRESHOLD: {
        ID: 'maxAuthAggThreshold',
        NAME: 'Maximum entries for logs aggregation',
        DESC: 'Limit the number of logs that can be processed for log aggregation exporting reports (limited to 1M)'
    },
    AUTO_DENY_MFA_THRESHOLD: {
        ID: 'autoDenyMfaThreshold',
        TAGS: ['Adaptive Block (MFA Bombing Protection)'],
        DESC: 'When configured, Silverfort automatically blocks MFA requests based on the specified number of MFA requests with the same user and policy identifiers that are denied by the user over the specified time period.'
    },
    AUTO_DENY_MFA_WINDOW_SIZE: {
        ID: 'autoDenyMfaWindowSize',
        TAGS: ['Adaptive Block (MFA Bombing Protection)']
    }
};

export const RADIUS_FIELDS = {
    IP_ADDRESS: {
        ID: 'ipAddress',
        NAME: 'RADIUS Client IP/CIDR',
        DESC: 'Address of RADIUS Client'
    },
    SECRET: {
        ID: 'secret',
        NAME: 'Secret',
        DESC: 'Copy the secret to the RADIUS client (or enter a value for the secret from the client). It is used to secure communication with Silverfort.'
    },
    ENABLE_RADIUS_OTP: {
        ID: 'enableOTP',
        NAME: 'Enable RADIUS OTP'
    },
    DISABLE_FIRST_FACTOR: {
        ID: 'disableFirstFactor',
        NAME: 'RADIUS as first factor'
    },
    ID: {
        ID: 'id',
        NAME: 'Id'
    }
};

export const FAIL_CLOSE_FIELDS = {
    NON_AD_PROTOCOLS: {
        ID: 'nonAdProtocols',
        NAME: 'Non-AD Protocols',
        DESC: 'Enable Fail-Close for Non-AD protocols (such as RADIUS, ADFS, Okta, etc.)',
        SAAS_DESC: 'Enable Fail-Close for Non-AD protocols (for example, OIDC, Desktop App, or others)'
    },
    AD_PROTOCOLS: {
        ID: 'adProtocols',
        NAME: 'AD Protocols',
        DESC: 'Configure Fail-Close ranges for AD protocols. Otherwise, it will be Fail-Open.'
    }
};

export const PACKET_FWD_ADDRESS_FIELDS = {
    ADDRESS_TYPE: { ID: 'addressType' },
    SUBNET: {
        ID: 'subnet',
        NAME: 'IP Address or Subnet',
        DESC: 'Enter an individual IP address or subnet CIDR for which {packet-fwd-type} will be applied'
    },
    RANGE_START: {
        ID: 'rangeStart',
        NAME: 'Start IP Address',
        DESC: 'Enter an IP address range for which {packet-fwd-type} will be applied'
    },
    RANGE_END: { ID: 'rangeEnd', NAME: 'End IP Address' },
    PROTOCOL: { ID: 'protocol', NAME: 'Protocols' },
    TYPE: { ID: 'rangeType', NAME: 'Type' },
    NOTES: { ID: 'notes', NAME: 'Notes' }
};

export const SELECTIVE_FWD_FIELDS = {
    SELECTIVE_FORWARDING: {
        ID: 'selectiveFwd',
        NAME: 'Selective Forwarding - Exclude IP range from Silverfort coverage',
        DESC: 'Select an IP range to exclude from Silverfort coverage'
    },
    EXCLUDE_EXCHANGE_SERVERS: {
        ID: 'exchangeServersTraffic',
        NAME: 'Exchange server traffic'
    }
};

export const SMTP_SERVER_FIELDS = {
    SMTP_ENABLED: {
        ID: 'smtpEnabled',
        NAME: 'Use Custom Email Provider',
        DESC: 'When disabled Silverfort will use cloud mailing service',
        TAGS: ['SMTP Server URL', 'SMTP From Address', 'SMTP Account']
    },
    SMTP_SERVER_URL: {
        ID: 'smtpServerUrl',
        NAME: 'SMTP Server',
        DESC: 'Domain name or IP address of the SMTP Server, and (optionally) port.',
        TAGS: ['SMTP Server URL']
    },
    SMTP_FROM_ADDRESS: {
        ID: 'smtpFromAddress',
        NAME: 'SMTP From Address',
        DESC: 'The email address of the sender.'
    },
    SMTP_ACCOUNT: {
        ID: 'smtpAccount',
        NAME: 'SMTP Account',
        DESC: 'If authentication is required for the SMTP Server, enter access credentials.'
    }
};

export const NODE_FIELDS = {
    NODE_ID: { ID: 'nodeId' },
    NODE_NAME: {
        ID: 'nodeName',
        NAME: 'Node Name',
        DESC: 'Change the name of the Node. The default name is the hostname set when the Node was configured.'
    },
    DOMAINS: {
        ID: 'domains',
        NAME: 'Domains',
        DESC: 'Select Protected Domains for Node.'
    },
    DOMAIN: {
        ID: 'domain',
        NAME: 'Domain',
        DESC: 'Select Protected Domain for Node.'
    },
    LDAP_URL: {
        ID: 'ldapUrl',
        NAME: 'LDAP Server',
        DESC: `Enter the IP address or FQDN of the LDAP server with which Silverfort performs LDAP sync. Upload the Root CA certificate in Protected Domains and specify the LDAP server's FQDN in the LDAP Server for Secure AD Sync.`,
        TAGS: ['Use LDAPS']
    },
    USE_SECURE_LDAP: {
        ID: 'useSecureLdap',
        NAME: 'Use LDAPS',
        DESC: 'For Secure AD Sync, upload the Root CA certificate in the Protected Domains section.',
        TAGS: ['LDAP Server']
    },
    ADSYNC_NODE: {
        ID: 'adsyncNode',
        NAME: 'Enable AD Sync',
        DESC: 'At least one Node per Protected Domain must have AD Sync enabled.'
    },
    RADIUS_NODE: {
        ID: 'radiusNode',
        NAME: 'Enable RADIUS',
        DESC: ''
    },
    DC_ADDRESS: {
        ID: 'dcAddress',
        NAME: 'DC Address',
        DESC: 'The IP address or FQDN of the DC used to verify RADIUS machine account credentials.'
    },
    RADIUS_MACHINE_ACCOUNT: {
        ID: 'radiusMachineAccount',
        NAME: 'RADIUS Machine Account',
        DESC: 'Machine Account used by the Silverfort RADIUS server to validate users against AD.'
    },
    HTTP_PROXY: {
        ID: 'httpProxy',
        NAME: 'HTTP/S Proxy',
        DESC: 'Enter Proxy URL (if one is used) for communication from this Node to the Silverfort Mobile Messaging Service. If SSL inspection (HTTPS) is used, create a bypass for the Silverfort Mobile Messaging Service.'
    },
    PROXY_ACCOUNT: {
        ID: 'proxyAccount',
        NAME: 'HTTP Proxy Account',
        DESC: 'Account credentials used to access the Proxy (if used).'
    },
    NODE_ENABLED: {
        ID: 'nodeEnabled',
        NAME: 'Node enabled'
    }
};

export const SECURITY_MAIN_FIELDS = {
    ADMIN_CONSOLE_ACCOUNT: {
        ID: 'adminConsoleAccount',
        NAME: 'Admin Console User',
        DESC: 'Login credentials for the Admin Console user.'
    },
    SESSION_TIMEOUT: {
        ID: 'sessionTimeout',
        NAME: 'Session Timeout'
    },
    HTTP_PROXY: {
        ID: 'httpProxy',
        NAME: 'HTTP Proxy'
    },
    HTTPS_PROXY: {
        ID: 'httpsProxy',
        NAME: 'HTTPS Proxy'
    },
    PROXY_ACCOUNT: {
        ID: 'proxyAccount',
        NAME: 'HTTP Proxy Account',
        DESC: 'Enter access credentials for proxy (if required)'
    },
    DR_RECOVERY: {
        ID: 'drRecovery',
        NAME: 'Admin Console Disaster Recovery Settings'
    },
    CERTIFICATE_REQUEST: {
        ID: 'certificateRequest',
        NAME: 'Admin Console Certificate Request'
    },
    CERTIFICATE: {
        ID: 'certificate',
        NAME: 'Admin Console Certificate'
    }
};

export const ADMIN_SECURITY_ROLES_FIELDS = {
    ROLE_NAME: {
        ID: 'securityRoleName',
        NAME: 'Role Name'
    },
    GUIDS: {
        ID: 'securityRoleGuids',
        NAME: 'Users and Groups'
    },
    DASHBOARD: {
        ID: 'dashboard',
        NAME: 'Dashboard',
        TAGS: ['Permissions']
    },
    POLICIES: {
        ID: 'policies',
        NAME: 'Policies',
        TAGS: ['Permissions']
    },
    SERVICE_ACCOUNTS: {
        ID: 'serviceAccounts',
        NAME: 'AD Service Accounts',
        TAGS: ['Permissions']
    },
    APP_DISCOVERY: {
        ID: 'applicationsDiscovery',
        NAME: 'App Discovery',
        TAGS: ['Permissions']
    },
    ACCESS_ANALYSIS: {
        ID: 'accessAnalysis',
        NAME: 'Access Intelligence',
        TAGS: ['Permissions']
    },
    INSIGHTS: {
        ID: 'insights',
        NAME: 'ISPM',
        TAGS: ['Permissions']
    },
    USERS: {
        ID: 'users',
        NAME: 'User Management',
        TAGS: ['Permissions']
    },
    EXCLUDE_USERS: {
        ID: 'excludeUsers',
        NAME: 'Temporarily exclude/resume users',
        TAGS: ['Permissions']
    },
    SEND_ENROLLMENT_EMAIL: {
        ID: 'sendEnrollmentEmail',
        NAME: 'Send enrollment email to groups of users'
    },
    SEND_ENROLLMENT_EMAIL_TO_UNPAIRED: {
        ID: 'sendEnrollmentEmailToAllUnpaired',
        NAME: 'Send enrollment email to all unpaired users'
    },
    MANAGE_PROTECTED_GROUPS: {
        ID: 'manageProtectedGroups',
        NAME: 'Manage protected groups'
    },
    DELETE_TOKENS: {
        ID: 'deleteUserTokens',
        NAME: 'Delete tokens',
        TAGS: ['Permissions']
    },
    TEST_USER_TOKENS: {
        ID: 'testUserTokens',
        NAME: 'Test tokens',
        TAGS: ['Permissions']
    },
    SET_EMAIL: {
        ID: 'setEmail',
        NAME: 'Set email',
        TAGS: ['Permissions']
    },
    MATCH_USERS: {
        ID: 'matchUsers',
        NAME: 'Match and unmatch users',
        TAGS: ['Permissions']
    },
    DISABLE_TOKENS: {
        ID: 'disableToken',
        NAME: 'Disable tokens',
        TAGS: ['Permissions']
    },
    LOGS: {
        ID: 'logs',
        NAME: 'Logs',
        TAGS: ['Permissions']
    },
    SYSTEM_STATUS: {
        ID: 'systemStatus',
        NAME: 'System Status',
        DESC: 'Monitor',
        TAGS: ['Permissions']
    },
    TOGGLE_SYSTEM_POWER: {
        ID: 'toggleSystemPower',
        NAME: 'Power Up/Down',
        TAGS: ['Permissions']
    },
    PREFORM_ADSYNC: {
        ID: 'preformAdsync',
        NAME: 'AD Sync',
        TAGS: ['Permissions']
    },
    NOTIFICATIONS: {
        ID: 'notifications',
        NAME: 'System Events',
        DESC: 'Monitor',
        TAGS: ['Permissions']
    },
    INVENTORY: {
        ID: 'inventory',
        NAME: 'Identity Graph and Inventory',
        TAGS: ['Permissions']
    },
    INVENTORY_AD: {
        ID: 'inventoryAd',
        NAME: 'Active Directory Inventory',
        TAGS: ['Permissions']
    },
    INVENTORY_CLOUD: {
        ID: 'inventoryCloud',
        NAME: 'Cloud Inventory',
        TAGS: ['Permissions']
    },
    SOFTWARE_UPDATES: {
        ID: 'softwareUpdates',
        NAME: 'Software Updates',
        DESC: 'Monitor',
        TAGS: ['Permissions']
    },
    PRIVILEGED_ACCOUNTS: {
        ID: 'privilegedAccounts',
        NAME: 'Privileged Access',
        TAGS: ['Permissions']
    },
    SETTINGS: {
        ID: 'settings',
        NAME: 'Settings',
        TAGS: ['Permissions']
    },
    AUTHORIZE: {
        ID: 'authorize',
        NAME: 'IDP Authorization',
        DESC: 'Integrations',
        TAGS: ['Permissions']
    },
    TEST_MFA_TOKENS: {
        ID: 'testMFATokens',
        NAME: 'Test tokens',
        DESC: 'MFA Tokens',
        TAGS: ['Permissions']
    },
    RISK: {
        ID: 'risk',
        NAME: 'ITDR',
        TAGS: ['Permissions']
    },
    CLOUD_NHI: {
        ID: 'cloudNhi',
        NAME: 'Cloud NHIs',
        TAGS: ['Permissions']
    },
    CLOUD_INTEGRATIONS: {
        ID: 'cloudIntegrations',
        NAME: 'Cloud Integrations',
        TAGS: ['Permissions']
    },
    CLOUD_ACCESS_ANALYSIS: {
        ID: 'accessAnalysisCloud',
        NAME: 'Cloud Access Intelligence',
        TAGS: ['Permissions']
    },
    CLOUD_AI_AGENT_SECURITY: {
        ID: 'aiAgentSecurityCloud',
        NAME: 'AI Agent Security',
        TAGS: ['Permissions']
    },
    CLOUD_AI_ACCESS_CONTROL: {
        ID: 'aiAccessControlCloud',
        NAME: 'AI Access Control',
        TAGS: ['Permissions']
    },
    CLOUD_INSIGHTS: {
        ID: 'cloudInsights',
        NAME: 'Cloud ISPM',
        TAGS: ['Permissions']
    },
    CLOUD_RISK: {
        ID: 'cloudRisk',
        NAME: 'Cloud ITDR',
        TAGS: ['Permissions']
    }
};

export const IS_VISIBLE_FIELD = {
    ID: 'isVisible'
};

export const LAST_MODIFIED_FIELD = {
    ID: 'lastModified'
};

export const DUO_MFA_TOKEN_FIELDS = {
    DUO_UPN_FIELD: {
        ID: 'duoUpnField',
        NAME: 'AD user identifier field',
        DESC: 'Which AD attribute maps to DUO identifier field.'
    },
    DUO_API_HOSTNAME: {
        ID: 'duoApiHostname',
        NAME: 'Duo API hostname'
    },
    DUO_INTEGRATION_KEY: {
        ID: 'duoIntegrationKey',
        NAME: 'Duo integration key'
    },
    DUO_SECRET_KEY: {
        ID: 'duoSecretKey',
        NAME: 'Duo secret key'
    },
    DUO_IS_VISIBLE: {
        ID: IS_VISIBLE_FIELD.ID
    },
    DUO_LAST_MODIFIED: {
        ID: LAST_MODIFIED_FIELD.ID
    }
};

export const RSA_MFA_TOKEN_FIELDS = {
    RSA_UPN_FIELD: {
        ID: 'rsaUpnField',
        NAME: 'AD user identifier field',
        DESC: 'Which AD attribute maps to RSA identifier field.'
    },
    RSA_REST_ENDPOINT: {
        ID: 'rsaRestEndpoint',
        NAME: 'RSA REST endpoint'
    },
    RSA_API_KEY: {
        ID: 'rsaApiKey',
        NAME: 'RSA API key'
    },
    RSA_IS_VISIBLE: {
        ID: IS_VISIBLE_FIELD.ID
    },
    RSA_LAST_MODIFIED: {
        ID: LAST_MODIFIED_FIELD.ID
    }
};

export const OKTA_MFA_TOKEN_FIELDS = {
    OKTA_UPN_FIELD: {
        ID: 'oktaUpnField',
        NAME: 'AD user identifier field',
        DESC: 'Which AD attribute maps to Okta identifier field.'
    },
    OKTA_URL: {
        ID: 'oktaUrl',
        NAME: 'Okta URL'
    },
    OKTA_API_TOKEN: {
        ID: 'oktaApiToken',
        NAME: 'Okta API token'
    },
    OKTA_IS_VISIBLE: {
        ID: IS_VISIBLE_FIELD.ID
    },
    OKTA_LAST_MODIFIED: {
        ID: LAST_MODIFIED_FIELD.ID
    }
};

export const PING_MFA_TOKEN_FIELDS = {
    PING_UPN_FIELD: {
        ID: 'pingUpnField',
        NAME: 'AD user identifier field',
        DESC: 'Which AD attribute maps to Ping identifier field.'
    },
    PING_API_KEY: {
        ID: 'pingApiKey',
        NAME: 'Ping Base64 API key'
    },
    PING_TOKEN: {
        ID: 'pingToken',
        NAME: 'Ping token'
    },
    PING_ORGANIZATION_ALIAS: {
        ID: 'pingOrganizationAlias',
        NAME: 'Ping organization alias'
    },
    PING_IDP_URL: {
        ID: 'pingIdpUrl',
        NAME: 'Ping IdP URL'
    },
    PING_IS_VISIBLE: {
        ID: IS_VISIBLE_FIELD.ID
    },
    PING_LAST_MODIFIED: {
        ID: LAST_MODIFIED_FIELD.ID
    }
};

export const MICROSOFT_MFA_TOKEN_FIELDS = {
    AAD_UPN_FIELD: {
        ID: 'aadUpnField',
        NAME: 'AD user identifier field',
        DESC: 'Which AD attribute maps to Microsoft identifier field.'
    },
    AAD_PUBLIC_KEY: {
        ID: 'aadPublicKeys',
        NAME: 'Entra ID Public Keys'
    },
    AAD_IS_VISIBLE: {
        ID: IS_VISIBLE_FIELD.ID
    },
    AAD_LAST_MODIFIED: {
        ID: LAST_MODIFIED_FIELD.ID
    }
};

export const ENTRA_ID_MFA_TOKEN_FIELDS = {
    ENTRA_ID_MFA_APPS: {
        ID: 'entraIdMfaApps'
    },
    ENTRA_ID_IS_VISIBLE: {
        ID: IS_VISIBLE_FIELD.ID
    }
};

export const HYPR_MFA_TOKEN_FIELDS = {
    HYPR_APP_ID: {
        ID: 'hyprAppId',
        NAME: 'HYPR app ID'
    },
    HYPR_URL: {
        ID: 'hyprUrl',
        NAME: 'HYPR URL'
    },
    HYPR_ACCESS_TOKEN: {
        ID: 'hyprAccessToken',
        NAME: 'HYPR access token'
    },
    HYPR_IS_VISIBLE: {
        ID: IS_VISIBLE_FIELD.ID
    },
    HYPR_LAST_MODIFIED: {
        ID: LAST_MODIFIED_FIELD.ID
    }
};

export const FIDO2_FIELDS = {
    FIDO2_MODE: {
        ID: 'fido2Mode',
        NAME: 'FIDO2 mode'
    },
    FIDO2_RP_ID: {
        ID: 'fido2RpId',
        NAME: 'FIDO2 RP ID'
    },
    FIDO2_ORIGIN: {
        ID: 'fido2Origin',
        NAME: 'FIDO2 origin'
    },
    FIDO2_IS_VISIBLE: {
        ID: IS_VISIBLE_FIELD.ID
    },
    FIDO2_LAST_MODIFIED: {
        ID: LAST_MODIFIED_FIELD.ID
    }
};

export const APPLICATION_SETTINGS_FIELDS = {
    MESSAGING_SERVICES_ENABLED: {
        ID: 'messagingServiceEnabled',
        NAME: 'On-Premise Desktop Messaging Services',
        DESC: 'Enable push notifications from On-Premise Desktop Messaging Service to Silverfort Desktop App.'
    },
    SAAS_MESSAGING_SERVICES_ENABLED: {
        ID: 'saasMessagingServiceEnabled',
        NAME: 'SaaS Desktop Messaging Services',
        DESC: 'Enable push notifications from SaaS Desktop Messaging Service to Silverfort Desktop App.'
    },
    MESSAGING_SERVICES_HA_ENABLED: {
        ID: 'messagingServiceHAEnabled',
        NAME: 'Desktop Messaging Service HA',
        DESC: 'Improve stability and enhance performance with Desktop Messaging Services High Availability (HA). In HA mode, Silverfort Nodes route messages directly to the On-premise Desktop Messaging Services, bypassing the Admin Console.'
    },
    DISPLAY_COMPANY_LOGO: {
        ID: 'displayCompanyLogo',
        NAME: 'Display Company Logo on Silverfort Desktop App',
        DESC: 'Display your company logo on the silverfort desktop application.'
    },
    CUSTOM_MFA_INTEGRATION: {
        ID: 'customMfaIntegration',
        NAME: 'Custom MFA integration',
        DESC: 'Enable integration between Silverfort Desktop Messaging Services and third party tokens.'
    },
    CUSTOM_MFA_INTEGRATION_KEY: {
        ID: 'customMfaIntegrationKey',
        NAME: 'Custom MFA integration key',
        DESC: 'Custom MFA integration key provided by Silverfort.'
    },
    USER_ENROLLMENT_WINDOW: {
        ID: 'userEnrollmentWindow',
        NAME: 'User Enrollment window',
        DESC: 'Select the shortcut keys.'
    },
    SECONDARY_URL: {
        ID: 'secondaryUrl',
        NAME: 'Secondary URL',
        DESC: 'Alternate URL to access the Silverfort Desktop Messaging Services (for example, for access from outside a VPN)'
    },
    DEFAULT_CERTIFICATE_REQUEST: {
        ID: 'certificateRequest',
        NAME: 'Default Desktop Messaging Service Certificate Request'
    },
    DEFAULT_CERTIFICATE: {
        ID: 'certificate',
        NAME: 'Default Desktop Messaging Service Certificate'
    }
};

export const DESKTOP_MESSAGING_SERVICES_FIELDS = {
    MESSAGING_SERVICES: {
        ID: 'messagingServices',
        NAME: 'Desktop Messaging Services',
        DESC: 'Set up the services in the desktop messaging services cluster.'
    }
};

export const MESSAGING_SERVICE_FIELDS = {
    ID_FIELD: { ID: 'id' },
    NAME: {
        ID: 'name',
        NAME: 'Name',
        DESC: 'The display name  for the Messaging Service.'
    },
    SERVER_URL: {
        ID: 'serverUrl',
        NAME: 'Messaging Service IP Address',
        DESC: 'Enter the IP address of the Messaging Service.'
    },
    DMZ: {
        ID: 'dmz',
        NAME: 'DMZ',
        DESC: 'Indicates whether Messaging Service resides in DMZ.'
    },
    CUSTOM_CERTIFICATE: {
        ID: 'customCertificate',
        NAME: 'Use Custom Certificate'
    },
    CERTIFICATE_REQUEST: {
        ID: 'certificateRequest',
        NAME: 'Custom Desktop Messaging Service Certificate Request'
    },
    CERTIFICATE: {
        ID: 'certificate',
        NAME: 'Custom Desktop Messaging Service Certificate'
    }
};

export const DESKTOP_NOTIFICATION_FIELDS = {
    NOTIFICATION_ICON: {
        ID: 'notificationIcon',
        NAME: 'Notification Icon'
    },
    NOTIFICATION_BACKGROUND: {
        ID: 'notificationBackground',
        NAME: 'Notification Background'
    },
    DISPLAY_ICON_ENABLED: {
        ID: 'displayIconEnabled',
        NAME: 'Display Notification Icon',
        DESC: 'Enable display of popup notification icon on Silverfort Desktop App'
    },
    NOTIFICATION_HEIGHT: {
        ID: 'notificationHeight',
        NAME: 'Window Height (px)'
    },
    NOTIFICATION_WIDTH: {
        ID: 'notificationWidth',
        NAME: 'Window Width (px)'
    },
    WINDOW_POSITION: {
        ID: 'windowPosition',
        NAME: 'Window Position'
    },
    NOTIFICATION_TITLE: {
        ID: 'notificationTitle',
        NAME: 'Notification Title'
    },
    MFA_NOTIFICATION_TEXT: {
        ID: 'mfaNotificationText',
        NAME: 'MFA Notification Text'
    },
    TIMEOUT_NOTIFICATION_TEXT: {
        ID: 'timeoutNotificationText',
        NAME: 'Timeout Notification Text'
    },
    NOTIFICATIONS_TIMEOUT: {
        ID: 'notificationsTimeout',
        NAME: 'Notification timeout (sec)',
        DESC: 'Length of time desktop notifications are displayed',
        TAGS: ['Show countdown']
    },
    SHOW_NOTIFICATIONS_TIMEOUT: {
        ID: 'showNotificationsTimeout',
        NAME: 'Show countdown',
        TAGS: ['Notification timeout (sec)']
    }
};

export const OTP_NOTIFICATION_FIELDS = {
    OTP_NOTIFICATION_ICON: {
        ID: 'otpNotificationIcon',
        NAME: 'MFA Icon'
    },
    OTP_NOTIFICATION_BACKGROUND1: {
        ID: 'otpNotificationBackground1',
        NAME: 'MFA Background (Step 1)'
    },
    OTP_NOTIFICATION_BACKGROUND2: {
        ID: 'otpNotificationBackground',
        NAME: 'MFA Background (Step 2)'
    },
    OTP_DISPLAY_ICON_ENABLED: {
        ID: 'otpDisplayIconEnabled',
        NAME: 'Display Notification Icon ',
        DESC: 'Enable display of popup notification icon on Silverfort Desktop App'
    },
    OTP_NOTIFICATION_HEIGHT: {
        ID: 'otpNotificationHeight',
        NAME: 'MFA Window Height (px)'
    },
    OTP_NOTIFICATION_WIDTH: {
        ID: 'otpNotificationWidth',
        NAME: 'MFA Window Width (px)'
    },
    OTP_WINDOW_POSITION: {
        ID: 'otpWindowPosition',
        NAME: 'MFA Window Position'
    },
    OTP_NOTIFICATION_TEXT: {
        ID: 'otpNotificationText',
        NAME: 'MFA Notification Text'
    },
    OTP_ON_AUTO_PAIRED_DEVICES: {
        ID: 'otpOnAutoPairedDevices',
        NAME: 'Show OTP On Auto Paired Devices'
    }
};

export const COMMON_FIELDS = {
    LDAP_IP_OPTIONS: { ID: 'ldapIpOptions' }
};

export const PROTECTED_DOMAIN_FIELDS = {
    DOMAIN_ID: { ID: 'domainId' },
    DOMAIN_NAME: {
        ID: 'domainName',
        NAME: 'Domain Name',
        DESC: 'Active Directory domain name'
    },
    DOMAIN_SHORT_NAME: {
        ID: 'domainShortName',
        NAME: 'Domain Short Name',
        DESC: 'NetBIOS domain name'
    },
    LDAP_DOMAIN_NAME: {
        ID: 'ldapDomainName',
        NAME: 'LDAP Domain Name',
        DESC: 'Domain name of the server that authenticates users logging into the Silverfort Admin Console'
    },
    LDAP_IP: {
        ID: 'ldapIp',
        NAME: 'LDAP Server',
        DESC: 'The LDAP server that authenticates users logging into the Silverfort Admin Console. Specify either an IP address or a domain name.',
        TAGS: ['Use Secure LDAP']
    },
    USE_SECURE_LDAP: {
        ID: 'useSecureLdap',
        NAME: 'Use Secure LDAP',
        TAGS: ['LDAP Server']
    },
    BACKUP_LDAP_IP: {
        ID: 'backupLdapIp',
        NAME: 'Backup LDAP Server',
        DESC: 'If the Primary LDAP Server specified above is not available, Admin Console users are authenticated using this server. Specify either an IP address or a domain name.',
        TAGS: ['Use Secure LDAP']
    },
    BACKUP_USE_SECURE_LDAP: {
        ID: 'backupUseSecureLdap',
        NAME: 'Use Secure LDAP',
        TAGS: ['Backup LDAP Server']
    },
    ASSIGNED_NODES: {
        ID: 'assignedNodes',
        NAME: 'Assigned Nodes',
        DESC: 'Silverfort Nodes assigned to this Domain'
    },
    ADSYNC_NODES: {
        ID: 'adsyncNodes',
        NAME: 'AD Sync Nodes',
        DESC: 'Each Protected Domain must have at least one Node configured to perform AD Sync. For optimal performance, specify two Nodes per Protected Domain and choose the Nodes with the best connectivity to the LDAP server.'
    },
    DOMAIN_SERVICE_ACCOUNT: {
        ID: 'domainServiceAccount',
        NAME: 'Domain Service Account',
        DESC: `An account that will be used for AD Sync. Full UPN is required.`
    },
    KERBEROS_FORWARDING: {
        ID: 'kerberosForwarding',
        NAME: 'Kerberos',
        TAGS: ['Protected Protocols']
    },
    NTLM_FORWARDING: {
        ID: 'NTLMForwarding',
        NAME: 'NTLM',
        TAGS: ['Protected Protocols']
    },
    LDAP_FORWARDING: {
        ID: 'LDAPForwarding',
        NAME: 'LDAP',
        TAGS: ['Protected Protocols']
    },
    LDAPS_FORWARDING: {
        ID: 'LDAPSForwarding',
        NAME: 'LDAPS',
        TAGS: ['Protected Protocols']
    },
    API_CERTIFICATE_REQUEST: {
        ID: 'APIcertificateRequest',
        NAME: 'API Certificate Request'
    },
    API_CERTIFICATE: {
        ID: 'APIcertificate',
        NAME: 'API Certificate'
    },
    ROOT_CA_CERTIFICATE: {
        ID: 'rootCAcertificate',
        NAME: 'Root CA Certificate'
    }
};

export const AVAILABILITY_ZONE_FIELDS = {
    NAME: {
        ID: 'AvailabilityZoneName',
        NAME: 'Availability Zone Name',
        DESC: 'Change the name of this Availability Zone.'
    },
    PROTECTED_DOMAINS: {
        ID: 'ProtectedDomains',
        NAME: 'Domains',
        DESC: 'Select Protected Domains for this Availability Zone.'
    },
    SF_NODES: {
        ID: 'SfNodes',
        NAME: 'Silverfort Nodes',
        DESC: 'Silverfort Nodes assigned to this Availability Zone.'
    },
    DCS: {
        ID: 'DomainControllers',
        NAME: 'Domain Controllers',
        DESC: 'Domain Controllers assigned to this Availability Zone.'
    }
};

export const ADFS_APP_FIELDS = {
    GUID_FIELD: { ID: 'guid' },
    IDENTIFIER: {
        ID: 'identifier',
        NAME: 'Identifier',
        DESC: 'The app identifier'
    },
    NAME: {
        ID: 'name',
        NAME: 'Name',
        DESC: 'The name of the app'
    },
    PROTOCOL: {
        ID: 'protocol',
        NAME: 'Protocol',
        DESC: 'Select the protocol for the ADFS app'
    }
};

export const PINGFED_APP_FIELDS = {
    GUID_FIELD: { ID: 'guid' },
    IDENTIFIER: {
        ID: 'identifier',
        NAME: 'Identifier',
        DESC: 'The app identifier'
    },
    NAME: {
        ID: 'name',
        NAME: 'Name',
        DESC: 'Name of the app'
    }
};

export const AZURE_CONNECTORS_FIELDS = {
    AZURE_AD_CONNECTOR: {
        ID: 'azureADConnector',
        NAME: 'Entra ID Connectors',
        DESC: 'Allows Silverfort to sync operational and informational data from Entra ID, including sign-in logs, users, roles, applications, and more.'
    },
    AZURE_REDIRECT_URI: {
        ID: 'azureRedirectUri',
        NAME: 'Entra ID Applications Redirect'
    },
    NEW_AZURE_AD_CONNECTOR: {
        ID: 'newAzureADConnector',
        NAME: 'Entra ID Connectors',
        DESC: 'Allows Silverfort to sync operational and informational data from Entra ID, including sign-in logs, users, roles, applications, and more.'
    },
    AZURE_AD_NAMING_CONVENTIONS: {
        ID: 'azureAdNamingConventions',
        NAME: 'Naming Conventions'
    }
};

export const AZURE_AD_ENTERPRISE_APPLICATIONS_FIELDS = {
    APP_NAME: {
        ID: 'appName',
        NAME: 'Application name',
        DESC: 'The Name of the Application.'
    },
    LOGIN_URL: {
        ID: 'loginUrl',
        NAME: 'Login URL',
        DESC: 'The Application Login URL.'
    },
    SAML_ENTITY_ID: {
        ID: 'SAMLEntityID',
        NAME: 'SAML Entity ID',
        DESC: 'The Application SAML Entity Identifier.'
    },
    SAML_CERTIFICATE: {
        ID: 'SAMLCertificate',
        NAME: 'SAML Certificate',
        DESC: 'The Application SAML Certificate.'
    },
    SAML_AZURE_AD_IDENTIFIER: {
        ID: 'SAMLAzureADIdentifier',
        NAME: 'SAML Entra ID Identifier',
        DESC: 'The SAML Entra ID Identifier.'
    }
};

export const SSO_APPLICATION_FIELDS = {
    CUSTOM_VENDOR: {
        ID: {
            ID: 'id',
            NAME: 'Application Id'
        },
        APP_NAME: {
            ID: 'applicationName',
            NAME: 'Application Name'
        },
        LOGIN_URL: {
            ID: 'loginUrl',
            NAME: 'Login URL'
        },
        AUDIENCE: {
            ID: 'audience',
            NAME: 'Audience'
        },
        CERTIFICATE: {
            ID: 'certificate',
            NAME: 'SAML Certificate'
        },
        ISSUER: {
            ID: 'issuer',
            NAME: 'Issuer'
        },
        VENDOR_ID: {
            ID: 'vendorId',
            NAME: 'IDP Name'
        },
        VENDOR_NAME: {
            ID: 'vendorName',
            NAME: 'IdP Name'
        },
        LOGIN_HINT: {
            ID: 'loginHint',
            NAME: 'Login Hint'
        },
        SOURCE: {
            ID: 'source',
            NAME: 'Source'
        }
    },
    ENTRA_ID: {
        ID: {
            ID: 'id',
            NAME: 'Application Id'
        },
        APP_NAME: {
            ID: 'applicationName',
            NAME: 'Application Name'
        },
        LOGIN_URL: {
            ID: 'loginUrl',
            NAME: 'Login URL'
        },
        AUDIENCE: {
            ID: 'audience',
            NAME: 'SAML Entity ID'
        },
        CERTIFICATE: {
            ID: 'certificate',
            NAME: 'SAML Certificate'
        },
        ISSUER: {
            ID: 'issuer',
            NAME: 'SAML Entra ID Identifier'
        },
        VENDOR_ID: {
            ID: 'vendorId',
            NAME: 'IDP Id'
        },
        VENDOR_NAME: {
            ID: 'vendorName',
            NAME: 'IDP Name'
        },
        LOGIN_HINT: {
            ID: 'loginHint',
            NAME: 'Login Hint'
        }
    },
    OKTA: {
        ID: {
            ID: 'id',
            NAME: 'Application Id'
        },
        APP_NAME: {
            ID: 'applicationName',
            NAME: 'Application Name'
        },
        LOGIN_URL: {
            ID: 'loginUrl',
            NAME: 'Sign on URL'
        },
        AUDIENCE: {
            ID: 'audience',
            NAME: 'Audience Restriction'
        },
        CERTIFICATE: {
            ID: 'certificate',
            NAME: 'SAML Certificate'
        },
        ISSUER: {
            ID: 'issuer',
            NAME: 'Issuer'
        },
        VENDOR_ID: {
            ID: 'vendorId',
            NAME: 'IDP Id'
        },
        VENDOR_NAME: {
            ID: 'vendorName',
            NAME: 'IdP Name'
        },
        LOGIN_HINT: {
            ID: 'loginHint',
            NAME: 'Login Hint'
        }
    },
    PING_FEDERATE: {
        ID: {
            ID: 'id',
            NAME: 'Application Id'
        },
        APP_NAME: {
            ID: 'applicationName',
            NAME: 'Application Name'
        },
        LOGIN_URL: {
            ID: 'loginUrl',
            NAME: 'Single Sign On Service Location'
        },
        AUDIENCE: {
            ID: 'audience',
            NAME: "Partner's Entity ID (Connection ID)"
        },
        CERTIFICATE: {
            ID: 'certificate',
            NAME: 'SAML Certificate'
        },
        ISSUER: {
            ID: 'issuer',
            NAME: 'Entity ID '
        },
        VENDOR_ID: {
            ID: 'vendorId',
            NAME: 'IdP Id'
        },
        VENDOR_NAME: {
            ID: 'vendorName',
            NAME: 'IdP Name'
        },
        LOGIN_HINT: {
            ID: 'loginHint',
            NAME: 'Login Hint'
        }
    },
    ONE_LOGIN: {
        ID: {
            ID: 'id',
            NAME: 'Application Id'
        },
        APP_NAME: {
            ID: 'applicationName',
            NAME: 'Application Name'
        },
        LOGIN_URL: {
            ID: 'loginUrl',
            NAME: 'SAML 2.0 Endpoint'
        },
        AUDIENCE: {
            ID: 'audience',
            NAME: 'Audience'
        },
        CERTIFICATE: {
            ID: 'certificate',
            NAME: 'SAML Certificate'
        },
        ISSUER: {
            ID: 'issuer',
            NAME: 'Issuer URL'
        },
        VENDOR_ID: {
            ID: 'vendorId',
            NAME: 'IdP Id'
        },
        VENDOR_NAME: {
            ID: 'vendorName',
            NAME: 'IdP Name'
        },
        LOGIN_HINT: {
            ID: 'loginHint',
            NAME: 'Login Hint'
        }
    },
    CYBER_ARK: {
        ID: {
            ID: 'id',
            NAME: 'Application Id'
        },
        APP_NAME: {
            ID: 'applicationName',
            NAME: 'Application Name'
        },
        LOGIN_URL: {
            ID: 'loginUrl',
            NAME: 'Single Sign On URL'
        },
        AUDIENCE: {
            ID: 'audience',
            NAME: 'Audience'
        },
        CERTIFICATE: {
            ID: 'certificate',
            NAME: 'SAML Certificate'
        },
        ISSUER: {
            ID: 'issuer',
            NAME: 'Issuer'
        },
        VENDOR_ID: {
            ID: 'vendorId',
            NAME: 'IdP Id'
        },
        VENDOR_NAME: {
            ID: 'vendorName',
            NAME: 'IdP Name'
        },
        LOGIN_HINT: {
            ID: 'loginHint',
            NAME: 'Login Hint'
        }
    },
    THALES_STA: {
        ID: {
            ID: 'id',
            NAME: 'Application Id'
        },
        APP_NAME: {
            ID: 'applicationName',
            NAME: 'Application Name'
        },
        LOGIN_URL: {
            ID: 'loginUrl',
            NAME: 'Login URL'
        },
        AUDIENCE: {
            ID: 'audience',
            NAME: 'SAML Entity ID'
        },
        CERTIFICATE: {
            ID: 'certificate',
            NAME: 'Certificate Upload'
        },
        ISSUER: {
            ID: 'issuer',
            NAME: 'SAML AD Identifier'
        },
        VENDOR_ID: {
            ID: 'vendorId',
            NAME: 'IDP Name'
        },
        VENDOR_NAME: {
            ID: 'vendorName',
            NAME: 'IdP Name'
        },
        LOGIN_HINT: {
            ID: 'loginHint',
            NAME: 'Login Hint'
        },
    },
    BEYOND_IDENTITY: {
        ID: {
            ID: 'id',
            NAME: 'Application Id'
        },
        APP_NAME: {
            ID: 'applicationName',
            NAME: 'Application Name'
        },
        LOGIN_URL: {
            ID: 'loginUrl',
            NAME: 'IdP SSO URL'
        },
        AUDIENCE: {
            ID: 'audience',
            NAME: 'SP Audience URI'
        },
        CERTIFICATE: {
            ID: 'certificate',
            NAME: 'SAML Certificate'
        },
        ISSUER: {
            ID: 'issuer',
            NAME: 'IdP Issuer'
        },
        VENDOR_ID: {
            ID: 'vendorId',
            NAME: 'IDP Name'
        },
        VENDOR_NAME: {
            ID: 'vendorName',
            NAME: 'IdP Name'
        },
        LOGIN_HINT: {
            ID: 'loginHint',
            NAME: 'Login Hint'
        },
    },
};

export const NEW_AZURE_CONNECTOR_FIELDS = {
    TENANT_ID: {
        ID: 'tenantId',
        NAME: 'Tenant ID',
        DESC: 'Entra ID Tenant ID.'
    },
    TENANT_NAME: {
        ID: 'tenantName',
        NAME: 'Tenant Name',
        DESC: 'Entra ID Tenant Name.'
    },
    CLIENT_ID: {
        ID: 'clientId',
        NAME: 'Application ID',
        DESC: 'Entra ID Application ID.'
    },
    CLIENT_SECRET: {
        ID: 'clientSecret',
        NAME: 'Client Secret',
        DESC: 'Entra ID Application Client Secret.'
    },
    HAS_CLIENT_SECRET: { ID: 'hasClientSecret' },
    ROLES: { ID: 'azureRoles' }
};

export const AZURE_CONNECTOR_FIELDS = {
    APPLICATION_ID: {
        ID: 'applicationId',
        NAME: 'Application ID',
        DESC: 'Entra ID Application ID.'
    },
    CLIENT_SECRET: {
        ID: 'clientSecret',
        NAME: 'Client Secret',
        DESC: 'Entra ID Application Client Secret.'
    },
    TENANT_ID: {
        ID: 'tenantId',
        NAME: 'Tenant ID',
        DESC: 'Entra ID Tenant ID.'
    },
    ACCESS_TOKEN: { ID: 'accessToken' },
    REFRESH_TOKEN: { ID: 'refreshToken' },
    HAS_CLIENT_SECRET: { ID: 'hasClientSecret' },
    AUTHORIZED: { ID: 'authorized' },
    TYPE: { ID: 'type' }
};

export const OKTA_CONNECTORS_FIELDS = {
    OKTA_REDIRECT_URI: {
        ID: 'oktaRedirectUri',
        NAME: 'Okta Applications Redirect'
    },
    OKTA_BRIDGE_ENABLED: {
        ID: 'oktaBridgeEnabled'
    },
    OKTA_BRIDGE_CONNECTOR: {
        ID: 'oktaBridgeConnector'
    }
};
export const SSO_APP_VENDORS_FIELDS = {
    ENTRA_ID: {
        ID: 'entraId',
        NAME: 'Entra Id'
    },
    OKTA: {
        ID: 'okta',
        NAME: 'Okta'
    },
    PING_FEDERATE: {
        ID: 'pingFederate',
        NAME: 'Ping Federate'
    },
    ONE_LOGIN: {
        ID: 'oneLogin',
        NAME: 'OneLogin'
    },
    CYBER_ARK: {
        ID: 'cyberArk',
        NAME: 'CyberArk'
    },
    THALES_STA: {
        ID: 'thalesSta',
        NAME: 'Thales STA'
    },
    BEYOND_IDENTITY: {
        ID: 'beyondIdentity',
        NAME: 'Beyond Identity'
    },
    CUSTOM_VENDOR: {
        ID: 'customVendor',
        NAME: 'Custom Vendor'
    }
};

export const OKTA_CONNECTOR_FIELDS = {
    CLIENT_ID: {
        ID: 'clientId',
        NAME: 'Client ID'
    },
    CLIENT_SECRET: {
        ID: 'clientSecret',
        NAME: 'Client Secret'
    },
    OKTA_DOMAIN: {
        ID: 'oktaDomain',
        NAME: 'Okta Domain'
    },
    ACCESS_TOKEN: { ID: 'accessToken' },
    REFRESH_TOKEN: { ID: 'refreshToken' },
    HAS_CLIENT_SECRET: { ID: 'hasClientSecret' },
    AUTHORIZED: { ID: 'authorized' }
};

export const SILVERFORT_API_FIELDS = {
    ADFS_API_TOKEN: {
        ID: 'adfsApiToken',
        NAME: 'ADFS API Token',
        DESC: 'Token used for authentication between Silverfort ADFS Adapter and Silverfort Nodes. Use this when installing the Silverfort ADFS Adapter.'
    },
    SILVERFORT_MFA_API: {
        ID: 'silverfortMfaApi',
        NAME: 'Silverfort MFA API User',
        DESC: 'Account Credentials to access the Silverfort MFA API. Generates the ADFS API Token when configured.'
    },
    ADMIN_CONSOLE_API_KEY: {
        ID: 'adminConsoleApiKey',
        NAME: 'External API Key',
        DESC: 'Use this API key to access Service Accounts or Risk APIs from a public facing interface.'
    },
    ALLOW_EXTERNAL_RISK_API: {
        ID: 'allowExternalRiskApi',
        NAME: 'Allow API access from a public facing interface'
    },
    APP_USER_INACTIVITY_THRESHOLD: {
        ID: 'appUserInactivityDaysThreshold',
        NAME: 'App User Inactivity Days Threshold'
    }
};

export const DOMAIN_CERTIFICATE_FIELDS = {
    DOMAIN_NAME: {
        ID: 'domainName',
        NAME: 'Domain Name'
    },
    ROUTE: {
        ID: 'route',
        NAME: 'Route'
    },
    SANS: {
        ID: 'sANs',
        NAME: 'SANs'
    },
    ERROR: {
        ID: 'error',
        NAME: 'Route'
    }
};

export const CUSTOM_INSIGHTS_FIELDS = {
    ID_FIELD: { ID: 'id' },
    NAME: {
        ID: 'name',
        NAME: 'Insight Name'
    },
    LAST_MODIFIED: { ID: 'lastModified' },
    INCLUDE_NAMING_CONVENTIONS: {
        ID: 'includeNamingConventions',
        NAME: 'Naming Conventions'
    },
    EXCLUDE_NAMING_CONVENTIONS: {
        ID: 'excludeNamingConventions',
        NAME: 'Exclude Naming Conventions'
    },
    USERS_AND_GROUPS: {
        ID: 'usersAndGroups',
        NAME: 'In Scope'
    },
    EXCLUDED_USERS_AND_GROUPS: {
        ID: 'excluded',
        NAME: 'Out of Scope'
    },
    IS_STATIC_INSIGHT: {
        ID: 'isStatic'
    },
    INSIGHT_ENTITY_TYPE: {
        ID: 'entityType'
    }
};

export const NAMING_CONVENTIONS_FIELDS = {
    CONDITION: {
        ID: 'condition',
        NAME: 'Naming Convention',
        DESC: 'Enter the naming convention string.'
    },
    CONDITION_TYPE: {
        ID: 'conditionType',
        NAME: 'Condition Type',
        DESC: 'Select the location of the naming convention string in the entity name.'
    }
};

export const MAINTENANCE_FIELDS = {
    NODE_LOG_LEVEL: {
        ID: 'nodeLogLevel',
        NAME: 'Admin Console Log Level'
    },
    LOG_LEVEL: {
        ID: 'logLevel',
        NAME: 'Nodes Log Level'
    },
    PUSH_SERVICES_LOG_LEVEL: {
        ID: 'pushServicesLogLevel',
        NAME: 'Desktop Messaging Services Log Level'
    },
    OFFLINE_MODE: {
        ID: 'offlineMode',
        NAME: 'Offline Mode',
        DESC: 'Enabling Offline Mode will disable all communication with the Silverfort Mobile Messaging Service. Offline Mode is only recommended for air-gapped networks where Silverfort VMs do not have internet connectivity. When the Offline Mode status is changed, the Admin Console must be restarted.'
    },
    SEND_DIAGNOSTICS: {
        ID: 'sendDiagnostics',
        NAME: 'Share Diagnostics with Silverfort',
        DESC: 'Share diagnostic information with Silverfort daily. The information is used to improve the Risk Engine. You can opt to share anonymized information.'
    },
    SEND_DIAGNOSTICS_ANON: {
        ID: 'sendDiagnosticsAnon',
        NAME: 'Anonymous'
    },
    AUTO_AD_ADAPTER_UPGRADE: {
        ID: 'autoADAdapterUpgrade',
        NAME: 'Force automatic AD Adapter update',
        SAAS_DESC:
            'When enabled, the AD Adapter will be updated automatically (as long as the updater service on the DC is enabled). Otherwise, update the AD Adapter manually, in the Software Update section',
        DESC: 'When enabled, the AD Adapter will be updated automatically (as long as the updater service on the DC is enabled). Otherwise, update the AD Adapter manually, in the Software Update section.'
    },
    ALLOW_AZURE_OPENAI_USAGE: {
        ID: 'allowAzureOpenAiUsage',
        NAME: 'Allow Azure OpenAI Usage',
        DESC: 'Silverfort AI Filter utilizes the Azure OpenAI Service on Silverfort meta-data. Therefore, usage of the silverfort AI Filter may be subject to Microsoft`s terms.'
    },
    ADD_PASSWORD_TO_LOGS: {
        ID: 'addPasswordToLogs',
        NAME: 'Add password to view logs'
    },
    CLIENT_LOG_PASSWORD: {
        ID: 'ClientLogPassword',
        NAME: 'Add Password'
    },
    ALLOW_SEND_LOGS_TO_SILVERHUB: {
        ID: 'AllowSendLogsToSilverhub',
        NAME: 'Share system logs with Silverfort'
    },
    EXPIRE_SEND_LOGS_TO_SILVERHUB: {
        ID: 'ExpireSendLogsToSilverhubOn',
        NAME: 'Valid until'
    }
};

export const SF_SUPPORT_FIELDS = {
    SF_SUPPORT_ENABLED: {
        ID: 'silverfortSupportEnabled',
        NAME: 'Enable Silverfort Support',
        DESC: 'Grant Silverfort support team access to your Silverfort data'
    },
    SEND_DIAGNOSTICS: {
        ID: 'sendDiagnostics',
        NAME: 'Share Diagnostics with Silverfort',
        DESC: 'Share diagnostic information with Silverfort daily. The information is used to improve the Risk Engine. You can opt to share anonymized information.'
    },
    SEND_DIAGNOSTICS_ANON: {
        ID: 'sendDiagnosticsAnon',
        NAME: 'Anonymous'
    }
};

export const SSO_FIELDS = {
    SSO_ENABLED: {
        ID: 'ssoEnabled',
        NAME: 'Single Sign-On'
    },
    SSO_PROTOCOL: {
        ID: 'ssoProtocol',
        NAME: 'SSO Protocol'
    },
    SSO_CALLBACK_URL: {
        ID: 'ssoCallbackUrl',
        NAME: 'SSO Callback URL'
    },
    SSO_LOGIN_URL: {
        ID: 'ssoLoginUrl',
        NAME: 'SSO Login URL'
    },
    SSO_IDP_ISSUER: {
        ID: 'ssoIdpIssuer',
        NAME: 'SSO IdP Issuer'
    },
    SSO_BUTTON_TEXT: {
        ID: 'ssoButtonText',
        NAME: 'SSO Button Text'
    },
    SSO_ENABLED_AUTHN_CONTEXT: {
        ID: 'ssoEnableAuthnContext',
        NAME: 'Enable SSO Authentication Context'
    },
    SSO_AUTHN_CONTEXT: {
        ID: 'ssoAuthnContext',
        NAME: 'Authentication Method',
        DESC: 'Choose a different authentication context'
    },
    SSO_CERTIFICATE: {
        ID: 'ssoCertificate',
        NAME: 'SSO Certificate'
    }
};

export const ADVANCED_CONFIG_FIELDS = {
    CONFIG_ADMIN_CONSOLE: {
        ID: 'configAdminConsole',
        NAME: 'Configure Admin Console'
    },
    CONFIG_ALL_NODES: {
        ID: 'configureAllNodes',
        NAME: 'Configure All Nodes'
    },
    CONFIG_NODE: {
        ID: 'configureSpecificNode',
        NAME: 'Configure Specific Nodes'
    }
};

export const CONFIG_SPECIFIC_NODE_FIELDS = {
    CONFIG: { ID: 'config', TAGS: ['Configure Specific Node'] }
};

export const ELASTIC_CONFIG_FIELDS = {
    THRESHOLD_PERCENTAGE: {
        ID: 'thresholdPercentage',
        NAME: 'Storage use threshold ( % )',
        DESC: 'The storage threshold above which Silverfort will start removing log records to free up space. Some disk space is reserved for internal uses.'
    },
    EVENT_THRESHOLD_PERCENTAGE: {
        ID: 'eventThresholdPercentage',
        NAME: 'Storage use event ( % )',
        DESC: 'The storage threshold above which Silverfort will issue an event (in the Notifications page). Some disk space is reserved for internal uses.'
    },
    DISCONNECTIONS_FOR_NOTIFY: {
        ID: 'disconnectionsForNotify',
        NAME: 'Disconnections For Notify'
    },
    NUM_OF_SHARDS: {
        ID: 'numOfShards',
        NAME: 'Number Of Shards Of Authentication Logs'
    }
};

export const LICENSE_FIELDS = {
    LICENSE_KEY: {
        ID: 'licenseKey',
        NAME: 'License Key'
    },
    LICENSE_UPDATE_TIME: {
        ID: 'licenseUpdateTime',
        NAME: 'License Update Time'
    },
    LICENSE_SYNC_TIME: {
        ID: 'licenseSyncTime',
        NAME: 'License Sync Time'
    }
};

export const MOBILE_MESSAGING_SERVICES_FIELDS = {
    ADMIN_CONSOLE_SENDERS: {
        ID: 'adminConsoleSenders',
        NAME: 'Admin Console Senders'
    },
    ADMIN_CONSOLE_RECEIVERS: {
        ID: 'adminConsoleReceivers',
        NAME: 'Admin Console Receivers'
    },
    CONNECTION_STRING: { ID: 'connectionString' }
};

export const IS_NEW_FIELD = { ID: 'isNew' };
export const CREATED_AT_FIELD = { ID: 'createdAt' };

export const ACCOUNT_MATCHING_FIELDS = {
    ACCOUNT_MATCHING: {
        ID: 'accountMatching',
        NAME: 'Account Matching'
    },
    AD_FIELDS_CONFIG: {
        ID: 'adFieldsConfig',
        NAME: 'AD fields'
    },
    IS_CASE_SENSITIVE: {
        ID: 'isCaseSensitive',
        NAME: 'Case sensitive'
    },
    IS_TOKEN_SHARING_ENABLED: {
        ID: 'isTokenSharingEnabled',
        NAME: 'Token sharing'
    }
};

export const ENROLLMENT_SETTINGS_FIELDS = {
    MAX_TOKENS: {
        ID: 'UserTokensLimit',
        NAME: 'Maximum allowed tokens'
    },
    UNPAIRED_USER_POLICY: {
        ID: 'BlockUnpairedUsers',
        NAME: 'Unpaired User Policy'
    },
    ENROLLMENT_CONFIRMATION: {
        ID: 'SendNewTokenEmail',
        NAME: 'Enrollment Request'
    }
};
